"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySymbolsMap = exports.CurrencyShortNames = void 0;
const enums_1 = require("@finbackoffice/enums");
exports.CurrencyShortNames = {
    [enums_1.Currency.USDT_ERC20]: "USDT Erc20",
    [enums_1.Currency.USDT_TRC20]: "USDT Trc20",
};
exports.CurrencySymbolsMap = {
    [enums_1.Currency.USDT_ERC20]: "₮",
    [enums_1.Currency.KRW]: "₩",
    [enums_1.Currency.EUR]: "€",
    [enums_1.Currency.USD]: "$",
    [enums_1.Currency.DOGE]: "Ð",
    [enums_1.Currency.LTC]: "Ł",
    [enums_1.Currency.BTC]: "₿",
    [enums_1.Currency.ETH]: "Ξ",
    [enums_1.Currency.BRL]: "R$",
};
//# sourceMappingURL=currency.js.map